import { SteemActionType } from '@popup/steem/actions/action-type.enum';
const TokenMarketReducer = (state = [], { type, payload }) => {
    switch (type) {
        case SteemActionType.LOAD_TOKENS_MARKET:
            return payload;
        default:
            return state;
    }
};
export default TokenMarketReducer;
